<app-component-html-template
  [(relevantAnalysisTypes)]="relevantAnalysisTypes"
  [packagingComponent]="closure"
  [form]="form"
  [componentSubtypes]="componentSubtypes"
  [packagingComponentType]="packagingComponentType.Closure"
  [callerId]="callerId"
  [isPreview]="isPreview"
  [isTracked]="isTracked"
  [isFormLocked]="isFormLocked"
  [historyVersions]="historyVersions"
  [spinnerActive]="spinnerActive"
  [canEditForm]="canEditForm"
  [isUserValidator]="isUserValidator"
  [isEditPermitted]="isEditPermitted"
  [imageSource]="imageSource"
  [componentTypeSelectionLabel]="'component.fields.ofClosure' | transloco"
  [isInternallyTracked]="isInternallyTracked"
  (submitted)="onComponentSubmit($event)"
  (historicVersionClicked)="loadHistoryVersions(closure.id)"
  [isDataExchangeSubRequest]="isDataExchangeSubRequest"
  [isInOngoingDataExchange]="isInOngoingDataExchange"
  [isCreatingDataExchangeRequest]="isCreatingDataExchangeRequest()"
  (historicVersionChanged)="onHistoryVersionChange($event)"
  (versionRenamed)="changeClosureVersionName($event)"
  [subRequestInfo]="subRequestInfo"
  (commentAdded)="onSubRequestCommentAdded($event)"
  (finishSubRequestClicked)="onFinishSubRequest($event)"
  (approveSubRequestClicked)="onApproveSubRequest()"
  (reopenSubRequestClicked)="onReopenSubRequest()"
  (createDataExchangeRequestClicked)="createDataExchangeRequest($event)">
  <h1 header>{{ 'component.closure' | transloco }}</h1>

  <div doc>
    <app-doc-upload-section [(areaDto)]="closure.docArea" [isEditable]="canEditForm" [ppwrRelevant]="relevantAnalysisTypes.ppwrRelevant"> </app-doc-upload-section>
  </div>

  <div image>
    <app-image-upload [canEditForm]="canEditForm" [images]="closure.images" (filesEdited)="onFilesEdited()"> </app-image-upload>
  </div>

  <div certificate>
    <app-certificate-upload [canEditForm]="canEditForm" [certificates]="closure.certificates" [certificateTypes]="allCertificateTypes" (filesEdited)="onFilesEdited()">
    </app-certificate-upload>
  </div>

  <div pdf>
    <app-pdf-upload [canEditForm]="canEditForm" [pdfs]="closure.documents" (filesEdited)="onFilesEdited()"> </app-pdf-upload>
  </div>
</app-component-html-template>
